export const FOLLOW_STATUS_COMMUNITY_MAP = {
  self: { icon: '', text: '编辑资料' },
  needle_follow_other: { icon: require('./images/to_hook_community.png'), text: '关注' },
  had_follow_other: { icon: require('./images/hook_community.png'), text: '已关注' },
  had_follow_self: { icon: require('./images/return_hook_community.png'), text: '回关' },
  each_follow_other: { icon: require('./images/double_hook_community.png'), text: '互相关注' },
}



// WEBPACK FOOTER //
// ./src/modules/knowledge/constant.js